import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Global } from 'src/app/core/resources/global';
import { ReactiveForm } from 'src/app/core/resources/reactive-form';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { CargoResources } from '../../resources/cargo';
import { FormThirdPartyConsignmentService } from './form-third-party-consignment.service';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { StandardMapComponent } from 'src/app/shared/standard-map/standard-map.component';
import { ThirdParty, ThirdPartyAddress } from 'src/app/core/interfaces/thirdParty';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { LocationAddress } from 'src/app/core/interfaces/locationAddress';
import { GeoValidationService, MunicipalityPolygonData } from 'src/app/core/services/geo-validation.service';
import { municipalityPolygonValidator } from 'src/app/core/validators/municipality-polygon.validator';
declare var google: any;

@Component({
  selector: 'app-form-third-party-consignment',
  templateUrl: './form-third-party-consignment.component.html',
  styleUrls: ['./form-third-party-consignment.component.scss'],
  providers: [FormThirdPartyConsignmentService]
})
export class FormThirdPartyConsignmentComponent extends ReactiveForm implements OnInit {

  @ViewChild('inputAutocomplete') inputAutocomplete: any;
  @ViewChild(StandardMapComponent) standardMap: StandardMapComponent;
  activeLocation: object = {
    typeLocation: 'thirdParty'
  };
  cityControl = new FormControl('', Validators.required);
  cityOptions: OptionsAutocomplete = {
    title: 'Ciudad',
    appearance: 'outline',
    requireFullCity: true
  };
  citySubscription: Subscription;
  addressControl = new FormControl('', Validators.required);
  addressOptions: OptionsAutocomplete;
  addressSubscription: Subscription;
  addressInitialValue: string = '';
  validate = '';
  cityValidate = '';
  location: any;
  documentTypeNameControl: FormControl = new FormControl('', Validators.required);
  minDocument: number = 5;
  maxDocument: number = 15;
  keyMarker: string = 'newThirdParty'
  mapOptions: OptionsAutocomplete = {
    keyMarkerListener: this.keyMarker,
    clickMapIcon: this.global.pathMarkerOrigin,
    initialClickMap: true,
  };
  checkDuplicateThirdParty: boolean = false;
  currentThirdPartyList: ThirdParty[] = [];
  /** Polígono del municipio seleccionado, para mostrarlo y para mensajes UI. */
  selectedPolygon: MunicipalityPolygonData | null = null;
  loadingPolygon: boolean = false;
  constructor(
    private manualCreationCargoService: ManualCreationCargoService,
    private thirdPartyConsignmentService: FormThirdPartyConsignmentService,
    public dialog: MatDialog,
    public global: Global,
    public formBuilder: FormBuilder,
    private cargoResources: CargoResources,
    public utils: Utils,
    private snackService: SnackBarService,
    public dialogRef: MatDialogRef<FormThirdPartyConsignmentComponent>,
    private spinner: NgxSpinnerService,
    private geoValidation: GeoValidationService,
    @Inject(MAT_DIALOG_DATA) public dataDialog: {
      title: 'Remitente' | 'Destinatario',
      options: {
        city?: { municipalityCode?: string }, //Solo para creación manual de la carga
        municipalityCode?: string,
        parent?: string,
        thirdParty?: ThirdParty,
        currentThirdPartyList?: ThirdParty[],
        address?: { address?: string, location?: LocationAddress },
        branchOfficeName?: string,
        disableCityEdition?: boolean,
        alertMessage?: string,
        isInternational?: boolean,
      },
      exactTitle?: boolean,
      type?: 'edit' | 'create'
    }
  ) {
    super(
      formBuilder,
      cargoResources.thirdParty,
      cargoResources.thirdParty,
      cargoResources.thirdParty,
    );
    if (this.dataDialog && this.dataDialog.options) {
      if (this.dataDialog.options.address) {
        this.form.controls.address.patchValue(this.dataDialog.options.address);
        this.addressInitialValue = this.dataDialog.options.address.address;
        this.addressControl.setValue(this.dataDialog.options.address);
        this.mapOptions['singlePoint'] = {
          lat: this.dataDialog.options.address.location.lat,
          lng: this.dataDialog.options.address.location.lng,
          icon: this.global.pathMarkerOrigin
        };
        this.mapOptions = { ...this.mapOptions };
      }
      if (this.dataDialog.options.branchOfficeName || (this.dataDialog.options.address && this.dataDialog.options.address.address)) {
        this.form.controls.branchOfficeName.setValue(this.dataDialog.options.branchOfficeName || (this.dataDialog.options.address && this.dataDialog.options.address.address));
      }
      if (this.dataDialog.options.city && this.dataDialog.options.city.municipalityCode) {
        this.form.controls.municipalityCode.setValue(this.dataDialog.options.city.municipalityCode);
        this.cityOptions['initialMunicipalityCode'] = this.dataDialog.options.city.municipalityCode;
        this.cityOptions = { ...this.cityOptions };
        this.form.controls.parent.setValue(this.manualCreationCargoService.formCargoOwner.value.documentNumber);
      }
      if (this.dataDialog.options.municipalityCode) {
        this.form.controls.municipalityCode.setValue(this.dataDialog.options.municipalityCode);
        this.cityOptions['initialMunicipalityCode'] = this.dataDialog.options.municipalityCode;
        this.cityOptions = { ...this.cityOptions };
      }
      if (this.dataDialog.options.thirdParty) { //Creación de una dirección de tercero existente
        this.form.get('information').patchValue(this.dataDialog.options.thirdParty);
        this.form.get('information').disable();
        this.documentTypeNameControl.setValue({
          id: this.form.get('information.documentTypeId').value,
          name: this.form.get('information.documentTypeName').value
        });
        this.documentTypeNameControl.disable();
      }
      else this.checkDuplicateThirdParty = true;
      if (this.dataDialog.options.currentThirdPartyList) this.currentThirdPartyList = this.dataDialog.options.currentThirdPartyList;
    }
  }

  ngOnInit() {
    this.addressOptions = {
      title: 'Dirección',
      appearance: 'outline',
      ...(this.addressInitialValue ? { initialValue: this.addressInitialValue } : {}),
      showHintRequiredAddressSelection: true
    };
    this.setValidators();
    this.setSubscriptions();
  }

  private setValidators() {
    this.form.get('information.documentTypeId').setValidators(Validators.required);
    this.form.get('information.document').setValidators([Validators.required, Validators.minLength(this.minDocument), Validators.maxLength(this.maxDocument)]);
    this.form.get('information.name').setValidators(Validators.required);
    this.form.get('address.address').setValidators(Validators.required);
    this.form.get('branchOfficeName').setValidators(Validators.required);
    this.form.get('parent').setValidators(null);
    this.form.get('municipalityCode').setValidators(null);

    // Validación geográfica: la dirección (lat/lng) debe caer dentro del
    // polígono DIVIPOLA del municipio seleccionado. Bloquea el guardado
    // cuando el RNDC rechazaría la coordenada.
    // IMPORTANTE: se aplica sobre form.get('address'), no sobre el form raíz.
    // Los async validators de Angular solo corren cuando el control es VALID.
    // El form raíz es INVALID mientras otros campos requeridos estén vacíos,
    // por lo que el validador nunca se ejecutaría si se pone en la raíz.
    this.form.get('address').setAsyncValidators(
      municipalityPolygonValidator(this.geoValidation, () => {
        if (this.dataDialog && this.dataDialog.options && this.dataDialog.options.isInternational) return null;
        const cityValue: any = this.cityControl.value;
        const cityId: string = cityValue && cityValue.id ? cityValue.id : null;
        const locationCtrl = this.form.get('address.location');
        const loc: any = locationCtrl ? locationCtrl.value : null;
        if (!cityId || !loc || loc.lat == null || loc.lng == null) return null;
        // Skip cuando lat/lng son los valores default del template (0,0) =
        // todavía no eligió dirección.
        if (loc.lat === 0 && loc.lng === 0) return null;
        return { cityId, lat: +loc.lat, lng: +loc.lng };
      })
    );
    this.form.get('address').updateValueAndValidity();
  }

  private setSubscriptions() {
    this.addressSubscription = this.addressControl.valueChanges.subscribe(value => {
      console.log('[ThirdParty] addressControl changed:', value);
      // CRÍTICO: un solo patchValue al form principal (no a sub-controles en
      // cascada). Múltiples patchValue/setValue seguidos disparan el async
      // validator múltiples veces y se cancelan unos a otros, impidiendo que
      // el HTTP llegue a hacerse.
      if (value && value.address) {
        this.form.patchValue({
          address: value,
          branchOfficeName: value.address
        });
        this.standardMap.removeMarker(this.keyMarker);
        this.standardMap.createMarker(this.keyMarker, value.location.lat, value.location.lng, null, this.global.pathMarkerOrigin);
        this.standardMap.setCenterMap(value.location.lat, value.location.lng, 16);
      } else {
        this.form.patchValue({ address: this.cargoResources.thirdParty.address });
      }
      console.log(
        '[ThirdParty] post-patch form.address =',
        this.form.get('address') && this.form.get('address').value,
        '| city =', this.cityControl.value
      );
    });

    this.citySubscription = this.cityControl.valueChanges.subscribe(value => {
      console.log('[ThirdParty] cityControl changed:', value);
      if (value && value.id) {
        this.loadPolygonForCity(value.id);
      } else {
        this.clearPolygon();
      }
      if (value && value.id && this.dataDialog && this.dataDialog.options && this.dataDialog.options.disableCityEdition) {
        this.cityValidate = 'disable';
        this.citySubscription.unsubscribe();
      }
      // Re-disparar la validación geográfica (backend con polígono DANE) al cambiar la ciudad.
      this.form.get('address').updateValueAndValidity({ emitEvent: false });
    });
  }

  /**
   * Carga el polígono del municipio seleccionado y lo dibuja sobre el mapa.
   * Da feedback visual al usuario de los límites donde puede ubicar la dirección.
   */
  private loadPolygonForCity(cityId: string): void {
    this.loadingPolygon = true;
    this.geoValidation.getMunicipalityPolygon(cityId).subscribe(
      (poly) => {
        this.loadingPolygon = false;
        this.selectedPolygon = poly;
        if (this.standardMap && poly && poly.geometry) {
          this.standardMap.renderMunicipalityPolygon(poly.geometry, { color: '#2563eb', fillOpacity: 0.1 });
        }
      },
      () => {
        this.loadingPolygon = false;
        this.selectedPolygon = null;
      }
    );
  }

  private clearPolygon(): void {
    this.selectedPolygon = null;
    if (this.standardMap) this.standardMap.removeMunicipalityPolygon();
  }

  onSubmit() {
    this.validate = 'touched';
    this.cityValidate = 'touched';
    if (this.utils.errorMessagesCustomized(this.cityControl, 'ciudad')) return;
    // Si la validación geográfica async está en curso, esperarla y reintentar.
    if (this.form.pending) {
      this.form.statusChanges.pipe(
        filter(status => status !== 'PENDING'),
        take(1)
      ).subscribe(() => this.onSubmit());
      return;
    }
    // La dirección cae fuera del polígono DIVIPOLA del municipio seleccionado.
    const addressErrors = this.form.get('address') && this.form.get('address').errors;
    if (addressErrors && addressErrors.outsideMunicipality) {
      const err: any = addressErrors.outsideMunicipality;
      const where = err.municipalityName
        ? `${err.municipalityName}${err.departmentName ? ' (' + err.departmentName + ')' : ''}`
        : 'el municipio seleccionado';
      this.snackService.openSnackBar(
        `La dirección está fuera de ${where}. Verifica la ubicación en el mapa.`,
        undefined,
        'alert'
      );
      return;
    }
    if (this.form.invalid) {
      if (this.utils.errorMessagesCustomized(this.form.get('information.documentTypeId'), 'tipo de documento')) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('information.document'), 'número de documento', this.minDocument, this.maxDocument)) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('information.name'), 'nombre')) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('address.address'), 'dirección')) return;
      else if (this.utils.errorMessagesCustomized(this.form.get('branchOfficeName'), 'nombre de sede')) return;
      else this.snackService.openSnackBar(FormMessages.GENERAL_ERROR_DEFAULT, undefined, 'alert');
      return;
    }
    let body = this.form.getRawValue();
    body['municipalityCode'] = this.cityControl.value.id;
    if (this.dataDialog.type === 'edit') {
      this.dialogRef.close({ state: true, data: body });
      return;
    }
    if (this.checkDuplicateThirdParty) {
      const document = this.form.get('information.document').value;
      const documentType = this.form.get('information.documentTypeId').value;
      const duplicateThirdParty = this.currentThirdPartyList.find(thirdParty => {
        if (!thirdParty || !thirdParty.document || !thirdParty.documentType) return false;
        if (documentType === "3")
          return thirdParty.document.includes(document) && thirdParty.documentType === documentType;
        return thirdParty.document === document && thirdParty.documentType === documentType
      });
      if (duplicateThirdParty)
        return this.snackService.openSnackBar(`Ya existe un tercero con este número de documento (${duplicateThirdParty.name})`, undefined, 'alert');
    }
    this.spinner.show();
    this.thirdPartyConsignmentService.createThirdParty(body).subscribe(
      (success: ThirdPartyAddress) => {
        this.spinner.hide();
        if (success && success.errorRNDC && success.errorRNDC.error) {
          this.snackService.openSnackBar(success.errorRNDC.error, undefined, 'error');
        } else {
          this.snackService.openSnackBar(this.dataDialog.title + ' creado exitosamente');
          this.dialogRef.close({ state: true });
        }
      },
      (error) => {
        this.spinner.hide();
        this.snackService.openSnackBar('Ocurrió un problema creando el ' + this.dataDialog.title, undefined, 'error');
      }
    );
  }

  async onClickMap($event) {
    // Click en el mapa: capturamos lat/lng y hacemos reverse geocoding solo
    // para autocompletar el texto de la dirección. La validación de que el
    // punto cae dentro del municipio la hace el AsyncValidator del backend
    // (polígono DANE), no este componente.
    const lat = $event.latLng.lat();
    const lng = $event.latLng.lng();
    console.log('[ThirdParty] onClickMap lat/lng:', lat, lng);
    this.spinner.show();
    const result = await this.geocodeCoordinates(lat, lng);
    this.spinner.hide();
    console.log('[ThirdParty] geocodeCoordinates result:', result);
    if (!result) return;
    const address = result.formatted_address;
    const location = { lat, lng };
    console.log('[ThirdParty] setting address from map click:', address, location);
    this.addressOptions = { ...this.addressOptions, initialValue: address };
    this.addressControl.setValue({ address, location });
  }

  private geocodeCoordinates(lat: number, lng: number): Promise<any> {
    return new Promise((resolve) => {
      const geocoderService = new google.maps.Geocoder();
      geocoderService.geocode({ location: { lat, lng } }, (results) => {
        resolve(results && results.length ? results[0] : null);
      });
    });
  }

  onChangeDocumentType($event: MatSelectChange) {
    if ($event && $event.value) {
      this.form.controls.information.patchValue({
        documentTypeId: $event.value.id,
        documentTypeName: this.utils.toCapitalize($event.value.name)
      });
      this.maxDocument = $event.value.name === "NIT" ? 9 : 15;
      this.setValidators();
    }
  }

  displayDocumentTypeName(documentType): string | undefined {
    return documentType && documentType.name ? documentType.name : undefined;
  }

  get modalTitle(): string {
    if (!this.dataDialog || !this.dataDialog.title) return "Nueva dirección de tercero";
    if (this.dataDialog.exactTitle) return this.dataDialog.title;
    if (this.dataDialog.title.toLowerCase().includes('dirección')) return `Nueva ${this.dataDialog.title.toLowerCase()}`;
    return `Nuevo ${this.dataDialog.title}`;
  }

  ngOnDestroy() {
    if (this.addressSubscription) this.addressSubscription.unsubscribe();
    if (this.citySubscription) this.citySubscription.unsubscribe();
    this.clearPolygon();
    this.geoValidation.clearCache();
  }

}
